import { TGuestRSVPStep } from './types';

export const NAME_FORM_VALUE_DEBOUNCE_TIME = 500;

export const RSVP_FORM_STEPS: TGuestRSVPStep[] = [
  'RSVP_FORM.EVENTS',
  'RSVP_FORM.QUESTIONS',
  'RSVP_FORM.NOTE',
  'RSVP_FORM.SUMMARY',
  'RSVP_FORM.CONFIRMATION',
];
